import type { ReactElement } from 'react'

import { MepSettingsScreen } from './MepSettingsPage'
import type { SettingsSection } from './MepSettingsPage'

// Every station type raises a machine conflict but the shared ones: the
// setting names the exceptions, the screen is named after the rule.
const SECTIONS: Array<SettingsSection> = [
  {
    legend: 'Conflicto de máquina',
    numbers: [
      { key: 'conflictToleranceMin', label: 'Solape que avisa de conflicto de máquina (min)', hint: 'Dos personas en la misma máquina a la vez durante menos de esto no avisan (3).', integer: true },
    ],
    lists: [
      {
        key: 'sharedStationTypeIds',
        label: 'Tipos de estación que se comparten',
        hint: 'Ids de MRPeasy de los tipos que usan varias personas a la vez: no avisan de conflicto y solo se reparte el lote exacto (6, las mesas).',
      },
    ],
  },
]

/**
 * Administración → Mise en place → Máquinas que no se comparten (MEP-P C):
 * which station types warn when two people would use them at once.
 */
export const MepSharedMachinesPage = (): ReactElement => (
  <MepSettingsScreen
    title="Máquinas que no se comparten"
    intro="Una máquina la usa una persona cada vez: si el reparto pone a dos en la misma a la vez, el tablero avisa del conflicto. Todas avisan salvo los tipos de estación que se comparten, como las mesas."
    sections={SECTIONS}
    saveLabel="Guardar"
    savedText="Guardado · queda en el historial de configuración."
  />
)
